import RecommendationFieldSelect from './recommendation-field-select';

/**
 * "Recomendación de manejo" — the seed wizard bound to its management flavour.
 *
 * A route-level binding rather than a component: the wizard itself is shared, and this is only
 * here so the route table names a component instead of an inline closure.
 */
const ManagementRecommendationCreate = () => <RecommendationFieldSelect crop='corn' variant='management' />;

export default ManagementRecommendationCreate;
